/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
/* eslint-disable no-underscore-dangle, no-console */

/**
 * Simplified version of https://github.com/BerkeleyTrue/warning/blob/master/warning.js
 *
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

const __DEV__ = process.env.NODE_ENV !== 'production';

let warning = function (_condition, _message) {};

if (__DEV__) {
  warning = function (condition, message) {
    if (message === undefined) {
      throw new Error(
        '`warning(condition, message)` requires a warning ' +
          'message argument',
      );
    }
    if (!condition) {
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

export { warning };
